// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/config/filterRouter'
import element from 'element-ui'
import Icon from 'vue2-svg-icon/Icon.vue'
import BaiduMap from 'vue-baidu-map'
import Print from 'vue-print-nb'

import 'element-ui/lib/theme-chalk/index.css'
Vue.use(element)
Vue.component('icon', Icon)
Vue.use(BaiduMap,{ak:'2175fa7c8917dd8b089c41ed7dd828f5'})

Vue.use(Print); 

Vue.config.productionTip = false
Vue.prototype.bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js